
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkMailSendingProviderEnum } from '../models/work-mail-sending-provider-enum';
import { requiredBoolean } from './required-boolean.validator';
import { WorkMailSignatureSourceEnum } from '../models/work-mail-signature-source-enum';

export function getMailSenderConfigDtoFormGroup() {
return new FormGroup({
    provider: new FormControl<WorkMailSendingProviderEnum | undefined>(undefined, [Validators.required]),
    enforceNeutralSender: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    signatureSource: new FormControl<WorkMailSignatureSourceEnum | undefined>(undefined, [Validators.required]),
    providerManagesSignatures: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
    workOfficeSignaturesEnabled: new FormControl<boolean | undefined>(undefined, [requiredBoolean()]),
})
;
}
      